import { EMBED_DEFAULT_SIZE, EMBED_MAX_SIZE } from "~/feature/embed/constants";
import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";

// The size the dialog opens at: the default, raised to the minimum the content
// needs and never past the ceiling the fields enforce.
export const getAutoEmbedSize = (min: IEmbedSize): IEmbedSize => ({
  width: Math.min(
    EMBED_MAX_SIZE.width,
    Math.max(EMBED_DEFAULT_SIZE.width, min.width)
  ),
  height: Math.min(
    EMBED_MAX_SIZE.height,
    Math.max(EMBED_DEFAULT_SIZE.height, min.height)
  ),
});
